<template>
    <div class="relative">
        <form class="flex flex-col gap-4 p-4 border-gray-50 border rounded-lg" @submit="onSubmit"
            :class="{ 'sent': isSent }">
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">Name</span>
                    <input type="text" class="pw-text-black rounded-md border-gray-200 bg-gray-100 p-2"
                        placeholder="John Doe" required v-model="form.name" />
                </label>
            </div>
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">GH Username</span>
                    <div class="flex items-center gap-0">
                        <div
                            class="bg-gray-100 border border-gray-200 rounded-l-lg w-10 h-10 overflow-hidden flex items-center justify-center">
                            <img :src="`https://avatars.githubusercontent.com/${form.githubUsername}`" alt=""
                                class="object-cover" v-if="form.githubUsername" />
                            <Icon name="mdi:github" class="text-2xl" v-else />
                        </div>
                        <input type="text"
                            class="pw-text-black rounded-r-md h-10 w-3/4 border-gray-200 bg-gray-100 p-2" required
                            v-model="form.githubUsername" placeholder="GH Username" />
                    </div>
                </label>
            </div>
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">Email address</span>
                    <input type="email" class="pw-text-black rounded-md border-gray-200 bg-gray-100 p-2"
                        placeholder="johndoe@email.com" required v-model="form.email" />
                </label>
            </div>
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">Institute/Organization</span>
                    <input type="text" class="pw-text-black rounded-md border-gray-200 bg-gray-100 p-2"
                        placeholder="John organization" required v-model="form.institute" />
                </label>
            </div>
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">Team Name</span>
                    <input type="text" class="pw-text-black rounded-md border-gray-200 bg-gray-100 p-2"
                        placeholder="John Team" required v-model="form.teamName" />
                </label>
            </div>
            <div>
                <label class="flex flex-col">
                    <span class="font-bold text-sm">Add participants*</span>
                    <div class="flex flex-wrap gap-2">
                        <div class="flex flex-wrap md:flex-nowrap gap-4 w-full">
                            <input type="text"
                                class="pw-text-black rounded-md border-gray-200 bg-gray-100 w-full md:w-max p-2"
                                required v-model="form.participants[0].name" placeholder="Name" />
                            <input type="text"
                                class="pw-text-black rounded-md border-gray-200 bg-gray-100 w-full md:w-max p-2"
                                required v-model="form.participants[0].email" placeholder="Email" />
                            <div class="flex  items-center gap-0  w-full md:w-max">
                                <div
                                    class="bg-gray-100 border border-gray-200 rounded-l-lg w-10 h-10 overflow-hidden flex items-center justify-center">
                                    <img :src="`https://avatars.githubusercontent.com/${form.participants[0].githubUsername}`"
                                        alt="" class="object-cover" v-if="form.participants[0].githubUsername" />
                                    <Icon name="mdi:github" class="text-2xl" v-else />
                                </div>
                                <input type="text"
                                    class="pw-text-black rounded-r-md h-10 border-gray-200 bg-gray-100 w-3/4 md:w-max p-2"
                                    required v-model="form.participants[0].githubUsername"
                                    placeholder="GH Username" />
                            </div>
                        </div>
                        <button type="button" v-if="!moreParticipants" @click="addParticipant"
                            class="bg-primary-200 border border-primary-300 gap-2 p-2.5 w-56 rounded-md text-primary-500 flex justify-center items-center px-4 transition hover:bg-primary-500 hover:text-white">
                            <Icon name="heroicons:user-plus-16-solid" class="text-xl" />
                            <span class="text-sm font-bold">Add more</span>
                        </button>
                        <div class="flex flex-wrap md:flex-nowrap gap-2 w-full mt-4" v-else>
                            <input type="text"
                                class="pw-text-black rounded-md border-gray-200 bg-gray-100 w-full md:w-max p-2"
                                v-model="form.participants[1].name" placeholder="Name" />
                            <input type="text"
                                class="pw-text-black rounded-md border-gray-200 bg-gray-100 w-full md:w-max p-2"
                                required v-model="form.participants[1].email" placeholder="Email" />
                            <div class="flex items-center gap-0 w-full md:w-max">
                                <div
                                    class="bg-gray-100 border border-gray-200 rounded-l-lg w-10 h-10 overflow-hidden flex items-center justify-center">
                                    <img :src="`https://avatars.githubusercontent.com/${form.participants[1].githubUsername}`"
                                        alt="" class="object-cover" v-if="form.participants[1].githubUsername" />
                                    <Icon name="mdi:github" class="text-2xl" v-else />
                                </div>
                                <input type="text"
                                    class="pw-text-black rounded-r-md h-10 border-gray-200 bg-gray-100 w-full md:w-max p-2"
                                    required v-model="form.participants[1].githubUsername"
                                    placeholder="GH Username" />
                            </div>
                        </div>
                    </div>
                    <span class="text-xs mt-1 text-gray-500">* minimum of 2 and a maximum of 3 members per team</span>
                </label>
            </div>
            <button type="submit"
                class="flex gap-2 mt-4 text-white ml-auto items-center font-bold hover:bg-transparent hover:text-primary-500 block max-w-max bg-primary-500 px-3 py-2 rounded-lg border-2 border-primary-500 !transition">
                <Icon name="heroicons:paper-airplane-20-solid" />
                Send
            </button>
        </form>
        <div v-if="isSent"
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-secondary-500 text-white p-3 w-full h-1/2 rounded-lg">
            <p><span class="font-bold">Important:</span> To complete your registration, please have your team
                members star the following GitHub repos to join the Pathway open-source community:</p>
            <div class="flex gap-3 justify-center mt-5">
                <a href="https://github.com/pathwaycom/pathway">
                    <img src="https://opengraph.githubassets.com/f06c0cab032a6e53d8228251b78f489e2e8867976035909a6327b44685c685d6/pathwaycom/pathway"
                        alt="" class="max-w-full max-h-[30rem]" />
                </a>
                <a href="https://github.com/pathwaycom/llm-app">
                    <img src="https://repository-images.githubusercontent.com/668195240/f58d7a42-3f95-49d5-a3fd-b6972bff7834"
                        alt="" class="max-w-full max-h-[30rem]" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from 'axios'
const { $showToast } = useNuxtApp()
const moreParticipants = ref(false)
const form = ref({
    name: "",
    githubUsername: "",
    email: "",
    institute: "",
    teamName: "",
    participants: [{
        name: "",
        githubUsername: "",
        email: ""
    },
    {
        name: "",
        githubUsername: "",
        email: ""
    }
    ]
})
const isSent = ref(false)

const addParticipant = () => {
    moreParticipants.value = true
}

const onSubmit = async (ev) => {
    ev.preventDefault()
    isSent.value = true
    await axios.post("https://www.formbackend.com/f/48dca6181d82d363", form.value)
        .then(() => {
            const { $showToast } = useNuxtApp()
            $showToast(`The message has been sent!`, 'success', 3000)
        }).catch((e) => {
            const { $showToast } = useNuxtApp()
            console.error(e)
            $showToast('Whoops, something went wrong!', 'error', 3000)
        })
}
</script>

<style scoped>
.sent {
    opacity: 0.2;
    pointer-events: none;
}

input:valid {
    border-color: var(--colors-primary-300);
}
</style>
